let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("JdgC1")).then(() => parcelRequire('cdusb'));